import useWaitingMutation from '@common/hooks/useWaitingMutation';
import { sendBroadcast } from '../../../../services/broadcastService';
import { Id } from '@common/types';
import { toast } from 'react-toastify';

interface ISendBroadcastParams {
  taskId: Id;
  recipientIds: Id[];
}

export const useSendBroadcast = () => {
  const { mutateAsync, isLoading } = useWaitingMutation(
    ({ taskId, recipientIds }: ISendBroadcastParams) => sendBroadcast(taskId, recipientIds),
    {
      onError: () => {
        toast.error('Failed to send broadcast');
      },
    },
  );

  return {
    sendBroadcast: mutateAsync,
    isSending: isLoading,
  };
};
